import { Avatar, Button, TextField } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import {
  HiChartBar,
  HiCheckCircle,
  HiOutlinePhotograph,
  HiOutlineVideoCamera,
  HiQuestionMarkCircle,
} from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Typography from "@material-ui/core/Typography"
import { fetchAllContent } from "../../../redux/dataFetchers/contentApi";
import Swal from "sweetalert2";
import Close from "@material-ui/icons/Close";
import { Cancel } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: "7px",
  },
  label: {
    margin: "0.3rem",
    height:"1.3rem"
  },
  typography:{
    textAlign:'left'
  },
  labelsContainer:{
    margin:'1rem 0'
  }
}));

const labels = [
  "HR",
  "Recruitment",
  "Tech",
  "AI/ML",
  "Coding",
  "Data Science",
  "Cloud",
  "IT",
  "Hiring",
];

export default function CreateContent() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const reduxState = useSelector((state) => state);
  const [openQna, setOpenQna] = useState(false);
  const [openPost, setOpenPost] = useState(false);
  const [openPoll, setOpenPoll] = useState(false);
  const [accessWarning, setAccessWarning] = useState(false);
  const optionRef = useRef(null);
  
  //Post Fields
  const [content, setContent] = useState("");
  const [mediaType, setMediaType] = useState("post");
  const [media, setMedia] = useState(null);
  const [selectedPostLabels, setSelectedPostLabels] = useState([]);
  const postLabelsRef = useRef([]);

  //QNA Fields
  const [question, setQuestion] = useState("");
  const [qnaDesc, setQnaDesc] = useState("");
  const [selectedQnaLabels, setSelectedQnaLabels] = useState([]);
  const qnaLabelsRef = useRef([]);

  //Poll Fields
  const [pollQuestion, setPollQuestion] = useState("");
  const [pollDesc, setPollDesc] = useState("");
  const [pollOption, setpollOption] = useState("");
  const [pollOptions, setpollOptions] = useState([]);
  const [selectedPollLabels, setSelectedPollLabels] = useState([]);
  const pollLabelsRef = useRef([]);

  const savePost = async (event) => {
    setOpenPost(false);
    console.log(content);
    setOpenPost(false);
    if (!content) {
      return Swal.fire({
        icon:'info',
        text:'Post Content is required!'
      })
    }
    
    //set post labels/tags
    const postLabels = [];
    let uniqueIndexes = Array.from(new Set(selectedPostLabels));
    
    for (let i = 0; i < selectedPostLabels.length; i++) {
      postLabels.push(labels[uniqueIndexes[i]]);
    }

    let words = content.split(' ');
    words = words.reduce((acc,word) => {
      if(word[0] === '#') acc.push(word.substr(1,word.length-1))
      return acc;
    },[]);

    postLabels.concat(words)

    const token = window.localStorage.getItem("token");

    const formData = new FormData();
    formData.append('media',media);
    formData.append('author',reduxState.info.info.uid);
    formData.append('content',content);
    formData.append('tag',mediaType);
    formData.append('labels',postLabels);
    console.log(media);
    fetch(`https://recruitingmonk-v2.azurewebsites.net/posts/${mediaType}`, {
      method: "POST",
      headers: {
        Authorization: token,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((post) => {
        console.log(post);
        dispatch(fetchAllContent());
        setContent('');
      })
      .catch((err) => {
        console.log(err);
        return Swal.fire({
          icon:'error',
          text:'Unable to post at the moment! Please Try later'
        })
      });
  };

  const saveQna = (event) => {
    setOpenQna(false)
    //don't allow all empty fields
    setOpenQna(false);
    if (!question) 
    return Swal.fire({
      icon:'info',
      text:'Question is required!'
    })

    //set qna labels/tags
    const qnaLabels = [];
    let uniqueIndexes = Array.from(new Set(selectedQnaLabels));
    
    for (let i = 0; i < selectedQnaLabels.length; i++) {
      qnaLabels.push(labels[uniqueIndexes[i]]);
    }

    let words = qnaDesc.split(' ');
    words = words.reduce((acc,word) => {
      if(word[0] === '#') acc.push(word.substr(1,word.length-1))
      return acc;
    },[]);

    qnaLabels.concat(words)

    const qnaData = {
      author: reduxState.info.info.uid,
      question: question,
      desc: qnaDesc,
      tag: "qna",
      labels:qnaLabels,
    };

    const token = window.localStorage.getItem("token");

    fetch(`https://recruitingmonk-v2.azurewebsites.net/qna`, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(qnaData),
    })
      .then((res) => res.json())
      .then((qna) => {
        console.log(qna);
        dispatch(fetchAllContent());
        setQuestion('');
        setQnaDesc('');
        //dispatch(setAllContent([...reduxState.allContent.posts,...reduxState.allContent.qnas]))
      })
      .catch((err) => {
        console.log(err);
        return Swal.fire({
          icon:'error',
          text:'Unable to ask Question at the moment! Please Try later'
        })
      });
  };

  const savePoll = (event) => {
    setOpenPoll(false);
    //don't allow all empty fields
    setOpenPoll(false);
    if (!pollQuestion || !pollOptions.size)
      return Swal.fire({
        icon:'info',
        text:'Poll Question and Options are required!'
      })
    if(pollOptions.size < 2 || pollOptions.size > 6)
    return Swal.fire({
      icon:'info',
      text:'Poll Options can be 2 to 6 Only!'
    })

    //set poll labels/tags
    const pollLabels = [];
    let uniqueIndexes = Array.from(new Set(selectedPollLabels));
    
    for (let i = 0; i < selectedPollLabels.length; i++) {
      pollLabels.push(labels[uniqueIndexes[i]]);
    }

    let words = pollDesc.split(' ');
    words = words.reduce((acc,word) => {
      if(word[0] === '#') acc.push(word.substr(1,word.length-1))
      return acc;
    },[]);

    pollLabels.concat(words)

    const pollData = {
      author: reduxState.info.info.uid,
      question: pollQuestion,
      desc: pollDesc,
      options:Array.from(pollOptions),
      tag: "poll",
      labels:pollLabels,
    };
    const token = window.localStorage.getItem("token");

    fetch(`https://recruitingmonk-v2.azurewebsites.net/poll`, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(pollData),
    })
    .then(response => {
      if(response.ok) {
          console.log(response)
          return response;
      }
      else {
          var error = new Error("Error " + response.status + ": " + response.statusText);
          error.response = response;
          throw error;
      }
    }, 
    error => {
      var errmess = new Error(error.message);
      throw errmess;
    })
      .then((res) => res.json())
      .then((qna) => {
        console.log(qna);
        dispatch(fetchAllContent());
        setPollQuestion('');
        setPollDesc('');
        setpollOption('');
        setpollOptions([]);
      })
      .catch((err) => {
        console.log(err);
        return Swal.fire({
          icon:'error',
          text:'Unable to create Poll at the moment! Try later'
        })
      });
  };

  const handlePostOpen = () => {
    if(reduxState.info.info.isAdmin)
      setOpenPost(true);
    else{
      setAccessWarning(true);
    }
  };

  const handlePostClose = () => {
    setOpenPost(false);
  };

  const handleQnaOpen = () => {
      setOpenQna(true);
  };

  const handleQnaClose = () => {
    setOpenQna(false);
  };
  const handlePollOpen = () => {
      setOpenPoll(true);
  };

  const handlePollClose = () => {
    setOpenPoll(false);
  };

  const addOptions = () => {
    if(!pollOption) return;
    // let options = pollOptions;
    // options.push(pollOption)
    setpollOptions([...pollOptions, pollOption])
    // setpollOptions(pollOptions => {
    //   let options = pollOptions;
    //   options.add(pollOption)
    //  return options;
    // })
    return setpollOption('');
  }
  const delOptions =  (coming) => {
    const rows = pollOptions.filter(option => option !== coming);

    setpollOptions(rows)
  }


  const postLabelSelected = (pos,label) => {

    // de-select interest if already selected
    if (postLabelsRef.current[pos].style.background) {
      postLabelsRef.current[pos].style.background = "";
      postLabelsRef.current[pos].style.color = "black";
      return setSelectedPostLabels((prevSelectedLabels) => {
        prevSelectedLabels.pop(Number(pos));
        return prevSelectedLabels;
      });
    }

    //select interest
    setContent(prevContent => prevContent + "#" + label)
    postLabelsRef.current[pos].style.background = "#B0343C";
    postLabelsRef.current[pos].style.color = "white";
    setSelectedPostLabels((prevSelectedLabels) => {
      prevSelectedLabels.push(Number(pos));
      return prevSelectedLabels;
    });
  };

  const qnaLabelSelected = (pos,label) => {

    // de-select interest if already selected
    if (qnaLabelsRef.current[pos].style.background) {
      qnaLabelsRef.current[pos].style.background = "";
      qnaLabelsRef.current[pos].style.color = "black";
      return setSelectedQnaLabels((prevSelectedLabels) => {
        prevSelectedLabels.pop(Number(pos));
        return prevSelectedLabels;
      });
    }

    //select interest
    setQnaDesc(prevQnaDesc => prevQnaDesc + "#" + label);
    qnaLabelsRef.current[pos].style.background = "#B0343C";
    qnaLabelsRef.current[pos].style.color = "white";
    setSelectedQnaLabels((prevSelectedLabels) => {
      prevSelectedLabels.push(Number(pos));
      return prevSelectedLabels;
    });
  };

  const pollLabelSelected = (pos,label) => {

    // de-select interest if already selected
    if (pollLabelsRef.current[pos].style.background) {
      pollLabelsRef.current[pos].style.background = "";
      pollLabelsRef.current[pos].style.color = "black";
      return setSelectedPollLabels((prevSelectedLabels) => {
        prevSelectedLabels.pop(Number(pos));
        return prevSelectedLabels;
      });
    }

    //select interest
    setPollDesc(prevPollDesc => prevPollDesc + "#" + label);
    pollLabelsRef.current[pos].style.background = "#B0343C";
    pollLabelsRef.current[pos].style.color = "white";
    setSelectedPollLabels((prevSelectedLabels) => {
      prevSelectedLabels.push(Number(pos));
      return prevSelectedLabels;
    });
  };

  return (
    <div className="glass flex flex-col p-2 md:mx-2 mb-5">
      <div className="flex flex-row items-center justify-between mb-2">
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={accessWarning}
        onClose={() => setAccessWarning(false)}
        closeAfterTransition
        disableAutoFocus = {true}
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade
          in={accessWarning}
          className="glass-6 flex flex-col items-center p-4 w-5/6 md:w-2/4 ring-0 border-0"
        >
          <div className="p-4 flex flex-col items-center">
            <h2
            className="ml-4 p-2 text-gray-800 select-none text-center font-bold text-md"
            >Oops! You Don't have access to Post!</h2>
            <Button fullWidth variant="contained" color="primary" style={{width:'50%'}}>Contact Us</Button>
          </div>
        </Fade>
      </Modal>
        <Avatar
          alt="profile icon"
          src={
            reduxState.authUser.isAuthenticated && reduxState.info.info.avatar
              ? reduxState.info.info.avatar
              : ""
          }
          className="avatar cursor-default"
        />
        <div
          onClick={handlePostOpen}
          className="rounded-lg ml-4 border-2 border-gray-200 bg-gray-200 w-full p-2 text-gray-800 select-none"
          style={{cursor:'text'}}
        >
          Something in mind? Jot it down...
        </div>
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openPost}
        onClose={handlePostClose}
        closeAfterTransition
        disableAutoFocus = {true}
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade
          in={openPost}
          className="glass-6 flex flex-col items-center p-4 w-5/6 md:w-2/4 ring-0 border-0"
        >
          <div className="p-4 flex flex-col items-center">
            <TextField multiline required fullWidth label="Write Post" value={content} onChange={(e) => setContent(e.target.value)} variant="outlined" maxRows={10} style={{margin:'1em 0em'}} />
            <div className={classes.labelsContainer} >
            <Typography className={classes.typography} >Add Tags</Typography>
                {labels.map((label, pos) => {
                  return (
                    <Button
                      className={classes.label}
                      ref={(el) => (postLabelsRef.current[pos] = el)}
                      style={{
                        fontWeight: "bold",
                      }}
                      variant={"contained"}
                      onClick={() => postLabelSelected(pos,label)}
                    >
                      {"#" + label}
                    </Button>
                  );
                })}
              </div>
            <div className="flex flex-row w-full justify-between items-center my-4 gap-4">
              <Button fullWidth variant="outlined" color="primary" component="label" startIcon={<HiOutlinePhotograph />}>
              Add Photo
              <input type="file" accept="image/*" hidden onChange={(e) => {
                setMediaType('post')
                console.log(e.target.files[0])
                setMedia(e.target.files[0])
                }} />
              </Button>
              <Button fullWidth variant="outlined" color="primary" component="label" startIcon={<HiOutlineVideoCamera />}>
              Add Video
              <input type="file" accept="video/*" onChange={(e) => {
                setMediaType('video');
                setMedia(e.target.files[0]);
              }} hidden/>
              </Button>
            </div>
            <Button fullWidth variant="contained" style={{background:"#B0343C",color:'white'}} onClick={savePost}>Post</Button>
          </div>
        </Fade>
      </Modal>
      <div className="flex flex-row items-center gap-2 justify-between">
        <div
          onClick={handleQnaOpen}
          className="cursor-pointer flex flex-row w-full flex-grow items-center bg-red-300 rounded-md p-1 px-2 text-sm font-bold text-gray-600 gap-2"
        >
          <HiQuestionMarkCircle />
          <p>Ask Question</p>
        </div>
        <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openQna}
        onClose={handleQnaClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade
          in={openQna}
          className="glass-6 flex flex-col items-center p-4 w-5/6 md:w-2/4 ring-0 border-0"
        >
          <div className="p-4 flex flex-col items-center ">
            <TextField multiline required fullWidth value={question} onChange={(e) => setQuestion(e.target.value)} label="Your Question" variant="outlined" maxRows={5} style={{margin:'1em 0em'}} />
            <TextField multiline fullWidth value={qnaDesc} onChange={(e) => setQnaDesc(e.target.value)} label="Description" variant="outlined" maxRows={5} style={{margin:'1em 0em'}} />
            <div className={classes.labelsContainer}>
            <Typography className={classes.typography} >Add Tags</Typography>
                {labels.map((label, pos) => {
                  return (
                    <Button
                      className={classes.label}
                      ref={(el) => (qnaLabelsRef.current[pos] = el)}
                      style={{
                        fontWeight: "bold",
                      }}
                      variant={"contained"}
                      onClick={() => qnaLabelSelected(pos,label)}
                    >
                      {"#" + label}
                    </Button>
                  );
                })}
              </div>
            <Button fullWidth variant="contained" style={{background:"#B0343C",color:'white'}} onClick={saveQna}>Ask your Question</Button>
          </div>
        </Fade>
      </Modal>
        <div
          onClick={handlePollOpen}
          className="cursor-pointer flex flex-row w-full flex-grow items-center bg-yellow-300 rounded-md p-1 px-2 text-sm font-bold text-gray-600 gap-2"
        >
          <HiChartBar />
          <p>Create Poll</p>
        </div>
        <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openPoll}
        onClose={handlePollClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade
          in={openPoll}
          className="glass-6 flex flex-col items-center p-4 w-5/6 md:w-2/4 ring-0 border-0"
        >
          <div className="p-4 flex flex-col items-center">
            <TextField multiline required fullWidth value={pollQuestion} onChange={(e) => setPollQuestion(e.target.value)} label="Your Question" variant="outlined" maxRows={5} style={{margin:'1em 0em'}} />
            <TextField multiline fullWidth value={pollDesc} onChange={(e) => setPollDesc(e.target.value)} label="Description" variant="outlined" maxRows={5} style={{margin:'1em 0em'}} />
            <div className="flex flex-row w-full items-center justify-between gap-2 my-2">
            <TextField label="Add Option" value={pollOption} required ref={optionRef} onKeyPress={(e) => {
              if(e.key === 'Enter') addOptions();
            }} onChange={(e)=> setpollOption(e.target.value)} variant="outlined" className="my-4 flex-grow" />
            <Button variant="contained" style={{background:"#B0343C",color:'white'}} onClick={() => addOptions()}>Add</Button>
            </div>
            <div className="flex flex-col w-full gap-2 my-2">
              {
                pollOptions?.map((option, index) => (
                  <p className="text-lg font-medium flex flex-row items-center justify-space-between"><Cancel style={{cursor:"pointer"}} onClick={() => delOptions(option)} /> {option}</p>
                ))
              }
            </div>
            <div className={classes.labelsContainer} >
            <Typography className={classes.typography} >Add Tags</Typography>
                {labels.map((label, pos) => {
                  return (
                    <Button
                      className={classes.label}
                      ref={(el) => (pollLabelsRef.current[pos] = el)}
                      style={{
                        fontWeight: "bold",
                      }}
                      variant={"contained"}
                      onClick={() => pollLabelSelected(pos,label)}
                    >
                      {"#" + label}
                    </Button>
                  );
                })}
              </div>
            <Button fullWidth variant="contained" style={{background:"#B0343C",color:'white'}} onClick={savePoll}>Create Poll</Button>
          </div>
        </Fade>
      </Modal>
        {/* <div>
          <div
            onClick={savePost}
            className="cursor-pointer flex flex-row items-center bg-blue-300 rounded-lg p-1 px-2 text-sm font-bold text-gray-600 gap-2"
          >
            <p>Post</p>
            <HiOutlineUpload />
          </div>
        </div> */}
      </div>
    </div>
  );
}